const AddressConstants = {
    ADDRESS_AUTO_COMPLETE: 'ADDRESS_AUTO_COMPLETE',
    ADDRESS_STATUS_FAILURE: 'FAILURE',
};

export default AddressConstants;
